'use strict';

require('./mm-scroll-into-view');
const mmWidgets = require('./mm-widgets'),
	gridDown = require('./grid-down'),
	gridUp = require('./grid-up'),
	addHotkey = require('./add-hotkey'),
	css = require('@mindmup/mapjs/src/dom/css');

mmWidgets.fn.storyboardWidget = function (storyboardController, storyboardModel, dimensionProvider, storyboardMapMediator, splittableModel, opts) {
	const options = opts || {},
		navigation = options.navigation || {
			gridLeft: (t) => t.previousElementSibling,
			gridRight: (t) => t.nextElementSibling,
			gridUp,
			gridDown
		};
	return mmWidgets.each(this, function () {
		const element = this,
			elementDOM = this.domElements[0],
			template = element.find('[data-mm-role=scene-template]'),
			noScenes = element.find('[data-mm-role=no-scenes]').detach(),
			templateParent = template.parent(),
			potentialDropTargets = function (dropPosition, includeActivated) {
				const //scenes = includeActivated ? templateParent.find('[data-mm-role=scene]').not('.drag-shadow') : templateParent.find('[data-mm-role=scene]').not('.activated-scene').not('.drag-shadow'),
					basicSelector = '[data-mm-role=scene]:not(.drag-shadow)',
					selector = includeActivated ? basicSelector : basicSelector + ':not(.activated-scene)',
					domScenes = Array.from(templateParent.domElements[0].querySelectorAll(selector)),
					row = domScenes.filter(function (sceneDOM) {
						const rect = sceneDOM.getBoundingClientRect(),
							ypos = dropPosition.top - rect.top,
							withinRow = (ypos > 0 && ypos < rect.height);
						return withinRow;
					}),
					lastInRowDOM = row[row.length - 1],
					lastSceneDOM = domScenes[domScenes.length - 1],
					potentialRightDOM = row.find(function (sceneDOM) {
						const rect = sceneDOM.getBoundingClientRect(),
							xpos = dropPosition.left - rect.left,
							leftMatch = (xpos > -40 && xpos < rect.width / 3);
						return leftMatch;
					}),
					potentialLeftDOM = row.find(function (sceneDOM) {
						const rect = sceneDOM.getBoundingClientRect(),
							xpos = dropPosition.left - rect.left,
							rightMatch = (xpos > rect.width * 2 / 3 && xpos < rect.width + 40);
						return rightMatch;
					});

				if (!potentialLeftDOM && !potentialRightDOM) {
					const lastInRowRect = lastInRowDOM && lastInRowDOM.getBoundingClientRect(),
						lastSceneRect = lastSceneDOM && lastSceneDOM.getBoundingClientRect();
					if (lastInRowDOM && dropPosition.left > lastInRowRect.left + lastInRowRect.width) {
						return {left: lastInRowDOM};
					} else if (lastSceneDOM && dropPosition.top > lastSceneRect.top) {
						return {left: lastSceneDOM};
					}
				}
				return {left: potentialLeftDOM, right: potentialRightDOM};
			},
			lastSceneBefore = function (sceneIndex) {
				const scenesBefore = templateParent.children().domElements.filter(domElement => {
					return domElement && domElement.mmData && domElement.mmData.scene && domElement.mmData.scene.index < sceneIndex;
				});
				// const scenesBefore =  _.reject(templateParent.children(), function (sceneDOM) {
				// 	return !mmWidgets(sceneDOM).data('scene') || sceneIndex < $(sceneDOM).data('scene').index;
				// });
				return scenesBefore[scenesBefore.length - 1];
			},
			setupSceneDragging = function (newScene, mmScene) {
				const newSceneDOM = newScene.domElements[0];
				newSceneDOM.setAttribute('draggable', 'true');
				newSceneDOM.addEventListener('dragstart', e => {
					e.dataTransfer.setData('vnd/mindmup-scene', JSON.stringify(mmScene));
				});
			},
			setSceneDOMContent = (sceneDOM, scene, dimensionProvider) => {
				const //sceneJQ = $(sceneDOM),
					dimensions = dimensionProvider.getDimensionsForScene(scene, sceneDOM.clientWidth, sceneDOM.clientHeight),
					titleDOM = sceneDOM.querySelector('[data-mm-role=scene-title]'),
					titleCSS = dimensions.text.toCss(),
					imageCSS =  dimensions.image.toCss();
				titleDOM.innerText = scene.title;
				css(titleDOM, titleCSS);
				css(sceneDOM, imageCSS);
			},
			addScene = function (scene, appendToEnd) {
				const newScene = template.clone()
					.data('scene', scene)
					.attr({
						'data-mm-role': 'scene',
						'data-mm-idea-id': scene.ideaId,
						'data-mm-index': scene.index
					})
					.on('click', function () {
						storyboardController.setSelectedScene(scene);
					}),
					target = !appendToEnd && lastSceneBefore(scene.index);
				if (!options.readOnly) {
					newScene.on('dblclick', function () {
						storyboardMapMediator.editNode(scene.ideaId);
					});
					setupSceneDragging(newScene, scene);
				}
				noScenes.detach();
				if (!templateParent.find('[data-mm-role=scene].activated-scene').length) {
					newScene.addClass('activated-scene');
					storyboardController.setSelectedScene(scene);
				}
				if (target) {
					target.insertAdjacentElement('afterend', newScene.domElements[0]);
				} else if (appendToEnd) {
					newScene.appendTo(templateParent);
				} else {
					newScene.prependTo(templateParent);
				}
				setSceneDOMContent(newScene.domElements[0], scene, dimensionProvider);
				newScene.domElements[0].style.opacity = 1;
				if (!appendToEnd) {
					storyboardController.setSelectedScene(scene);
					newScene.mmScrollIntoView();
				}
			},
			rebuildStoryboard = function () {
				const scenes = storyboardModel.getScenes();
				templateParent.empty();
				if (scenes && scenes.length) {
					scenes.forEach(scene => addScene(scene, true));
					// _.each(scenes, function (scene) {
					// 	addScene(scene, true);
					// });
				} else {
					noScenes.appendTo(templateParent).removeClass('hidden');
				}
			},
			findScene = function (scene) {
				return templateParent.find('[data-mm-role=scene][data-mm-index="' + scene.index + '"][data-mm-idea-id="' + scene.ideaId + '"]').domElements[0];
			},
			removeScene = function (scene) {
				const sceneDOM = findScene(scene),
					removeDOM = () => {
						const parentElement = sceneDOM.parentElement;
						if (parentElement) {
							sceneDOM.remove();
							if (!Array.from(parentElement.children).length) {
								noScenes.appendTo(templateParent).removeClass('hidden');
							}
						}
					};
				if (document.activeElement === sceneDOM) {
					element.focus();
				}
				if (sceneDOM) {
					sceneDOM.addEventListener('transitionend', removeDOM);
					sceneDOM.style.opacity = 0;
					setTimeout(removeDOM, 300);
				}
			},
			updateScene = function (scene) {
				const sceneDOM = findScene(scene);
				if (sceneDOM) {
					setSceneDOMContent(sceneDOM, scene, dimensionProvider);
				}
			},
			moveScene = function (moved) {
				const oldSceneDOM = findScene(moved.from);
				oldSceneDOM.remove();
				addScene(moved.to, false);
			},
			showStoryboard = function () {
				storyboardModel.setInputEnabled(true);
				rebuildStoryboard();
				storyboardModel.addEventListener('storyboardSceneAdded', addScene);
				storyboardModel.addEventListener('storyboardSceneMoved', moveScene);
				storyboardModel.addEventListener('storyboardSceneRemoved', removeScene);
				storyboardModel.addEventListener('storyboardSceneContentUpdated', updateScene);
			},
			hideStoryboard = function () {
				storyboardModel.setInputEnabled(false);
				storyboardModel.removeEventListener('storyboardSceneAdded', addScene);
				storyboardModel.removeEventListener('storyboardSceneMoved', moveScene);
				storyboardModel.removeEventListener('storyboardSceneRemoved', removeScene);
				storyboardModel.removeEventListener('storyboardSceneContentUpdated', updateScene);
			},
			select = function (jQSceneDOM) {
				if (!jQSceneDOM) {
					return;
				}
				const scene = jQSceneDOM && jQSceneDOM.mmData && jQSceneDOM.mmData.scene;
				if (scene) {
					storyboardController.setSelectedScene(scene);
				}
			},
			somethingDragged = (evt) => {
				let actualLeft, actualRight;
				const potentialDrops = potentialDropTargets({left: evt.clientX, top: evt.clientY}, true),
					scenes = templateParent.find('[data-mm-role=scene]');

				if (potentialDrops.left) {
					actualLeft = potentialDrops.left;
					actualRight = actualLeft.nextElementSibling;
				} else if (potentialDrops.right) {
					actualRight = potentialDrops.right;
					actualLeft = actualRight.previousElementSibling;
				}
				scenes.removeClass('potential-drop-left potential-drop-right');
				if (actualRight) {
					actualRight.classList.add('potential-drop-right');
				}
				if (actualLeft) {
					actualLeft.classList.add('potential-drop-left');
				}
			},
			sceneDropped = function (sceneData) {
				const potentialRight = templateParent.find('.potential-drop-right');
				let potentialLeft = templateParent.find('.potential-drop-left');
				if (potentialLeft.length) {
					storyboardController.moveSceneAfter(sceneData, potentialLeft.data('scene'));
				} else if (potentialRight.length) {
					potentialLeft = potentialRight.prev();
					if (potentialLeft.length) {
						storyboardController.moveSceneAfter(sceneData, potentialLeft.data('scene'));
					} else {
						storyboardController.moveSceneAfter(sceneData);
					}
				}
			},
			nodeDropped = ({nodeId})  => {
				const potentialRight = templateParent.find('.potential-drop-right');
				storyboardController.addScene(nodeId, potentialRight.data('scene'));
			},
			setUpDragging = function () {
				elementDOM.addEventListener('dragover', (evt) => {
					//TODO: check if there is some data we care about
					evt.preventDefault();
					evt.dataTransfer.dropEffect = 'move';
					somethingDragged(evt);
				});
				elementDOM.addEventListener('dragleave', () => {
					templateParent.children().removeClass('potential-drop-left potential-drop-right');
				});
				elementDOM.addEventListener('drop', (evt) => {
					const nodeDataString = evt.dataTransfer.getData('vnd/mindmup-node'),
						sceneDataString = evt.dataTransfer.getData('vnd/mindmup-scene');
					evt.preventDefault();
					evt.stopPropagation();
					if (nodeDataString) {
						nodeDropped(JSON.parse(nodeDataString), evt);
					} else if (sceneDataString) {
						sceneDropped(JSON.parse(sceneDataString), evt);
					}
					templateParent.children().removeClass('potential-drop-left potential-drop-right');
				});
			},
			setUpEditingKeys = function () {
				addHotkey(elementDOM, 'del backspace', function (event) {
					storyboardController.removeScene();
					event.preventDefault();
					event.stopPropagation();
				});
				addHotkey(elementDOM, 'alt+right', function (e) {
					storyboardController.moveSelectedSceneRight();
					e.preventDefault();
					e.stopPropagation();
				});
				addHotkey(elementDOM, 'alt+left', function (e) {
					storyboardController.moveSelectedSceneLeft();
					e.stopPropagation();
					e.preventDefault();
				});
			},
			setUpMovementKeys = function () {
				addHotkey(elementDOM, 'right', function (e) {
					select(navigation.gridRight(elementDOM.querySelector('.activated-scene')));
					e.stopPropagation();
					e.preventDefault();
				});
				addHotkey(elementDOM, 'left', function (e) {
					select(navigation.gridLeft(elementDOM.querySelector('.activated-scene')));
					e.stopPropagation();
					e.preventDefault();
				});
				addHotkey(elementDOM, 'up', function (e) {
					select(navigation.gridUp(elementDOM.querySelector('.activated-scene')));
					e.stopPropagation();
					e.preventDefault();
				});
				addHotkey(elementDOM, 'down', function (e) {
					select(navigation.gridDown(elementDOM.querySelector('.activated-scene')));
					e.stopPropagation();
					e.preventDefault();
				});
			};
		template.detach();
		templateParent.on('mouseleave', () => {
			templateParent.find('[data-mm-role=scene]').removeClass('potential-drop-left potential-drop-right');
		});
		splittableModel.addEventListener('show', function (sidebar) {
			if (sidebar ===	'Storyboard') {
				showStoryboard();
			} else {
				hideStoryboard();
			}
		});
		splittableModel.addEventListener('hide', hideStoryboard);

		storyboardController.addEventListener('storyboardContext', function (context) {
			if (context.selectedScene) {
				const sceneDOM = findScene(context.selectedScene);
				templateParent.find('[data-mm-role=scene]').removeClass('activated-scene');
				if (sceneDOM) {
					sceneDOM.classList.add('activated-scene');
				}
			}
		});
		if (!options.readOnly) {
			setUpDragging();
			setUpEditingKeys();
		}
		setUpMovementKeys();
	});
};
/*


 storyboard widget on shown -> notify controller that storyboard is active
 storyboard widget on hide -> notify controller that storyboard is no longer active

 controller -> model -> active storyboard -> event published

 model event -> addSceneWidget
	- attach/detach keyboard addSceneHandler
	- hide/show menu items
*/
